import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { RESPONSE_MESSAGE } from '../utils/constants'
import { message } from 'antd'

const GET_ALL_HERO_REQUEST = 'Hero/GET_ALL_HERO_REQUEST'
const GET_ALL_HERO_SUCCESS = 'Hero/GET_ALL_HERO_SUCCESS'
const GET_ALL_HERO_FAILURE = 'Hero/GET_ALL_HERO_FAILURE'

const GET_HERO_LOCATION_LIST_REQUEST = 'Hero/GET_HERO_LOCATION_LIST_REQUEST'
const GET_HERO_LOCATION_LIST_SUCCESS = 'Hero/GET_HERO_LOCATION_LIST_SUCCESS'
const GET_HERO_LOCATION_LIST_FAILURE = 'Hero/GET_HERO_LOCATION_LIST_FAILURE'

const GET_HERO_ME_REQUEST = 'Hero/GET_HERO_ME_REQUEST'
const GET_HERO_ME_SUCCESS = 'Hero/GET_HERO_ME_SUCCESS'
const GET_HERO_ME_FAILURE = 'Hero/GET_HERO_ME_FAILURE'

const GET_HERO_CONFIG_REQUEST = 'Hero/GET_HERO_CONFIG_REQUEST'
const GET_HERO_CONFIG_SUCCESS = 'Hero/GET_HERO_CONFIG_SUCCESS'
const GET_HERO_CONFIG_FAILURE = 'Hero/GET_HERO_CONFIG_FAILURE'

const SAVE_HERO_MATERIAL_REQUEST = 'Hero/SAVE_HERO_MATERIAL_REQUEST'
const SAVE_HERO_MATERIAL_SUCCESS = 'Hero/SAVE_HERO_MATERIAL_SUCCESS'
const SAVE_HERO_MATERIAL_FAILURE = 'Hero/SAVE_HERO_MATERIAL_FAILURE'

const SAVE_HERO_SETTING_REQUEST = 'Hero/SAVE_HERO_SETTING_REQUEST'
const SAVE_HERO_SETTING_SUCCESS = 'Hero/SAVE_HERO_SETTING_SUCCESS'
const SAVE_HERO_SETTING_FAILURE = 'Hero/SAVE_HERO_SETTING_FAILURE'

const SAVE_HERO_IMAGE_REQUEST = 'Hero/SAVE_HERO_IMAGE_REQUEST'
const SAVE_HERO_IMAGE_SUCCESS = 'Hero/SAVE_HERO_IMAGE_SUCCESS'
const SAVE_HERO_IMAGE_FAILURE = 'Hero/SAVE_HERO_IMAGE_FAILURE'

const UPDATE_HERO_PROFILE_REQUEST = 'Hero/UPDATE_HERO_PROFILE_REQUEST'
const UPDATE_HERO_PROFILE_SUCCESS = 'Hero/UPDATE_HERO_PROFILE_SUCCESS'
const UPDATE_HERO_PROFILE_FAILURE = 'Hero/UPDATE_HERO_PROFILE_FAILURE'

const RESET_PASSWORD_REQUEST = 'Hero/RESET_PASSWORD_REQUEST'
const RESET_PASSWORD_SUCCESS = 'Hero/RESET_PASSWORD_SUCCESS'
const RESET_PASSWORD_FAILURE = 'Hero/RESET_PASSWORD_FAILURE'

const CHECK_RESET_PASSWORD_REQUEST = 'Hero/CHECK_RESET_PASSWORD_REQUEST'
const CHECK_RESET_PASSWORD_SUCCESS = 'Hero/CHECK_RESET_PASSWORD_SUCCESS'
const CHECK_RESET_PASSWORD_FAILURE = 'Hero/CHECK_RESET_PASSWORD_FAILURE'

const STORE_HERO_DATA = 'Hero/STORE_HERO_DATA'

// Initialize State
const initialState = {
  user: {},
  isLoading: true,
  loginLoading: false,
  heroConfigLoading: true,
  error: {},
  locationList: [],
  heroList: [],
  heroConfigList: [],
  me: {}
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HERO_LOCATION_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_HERO_LOCATION_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        locationList: action.payload
      }
    case GET_HERO_LOCATION_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_ALL_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_ALL_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroList: action.payload
      }
    case GET_ALL_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_HERO_ME_REQUEST:
      return {
        ...state,
        loginLoading: true
      }
    case GET_HERO_ME_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        me: action.payload
      }
    case GET_HERO_ME_FAILURE:
      return {
        ...state,
        error: action.error,
        loginLoading: false
      }
    case GET_HERO_CONFIG_REQUEST:
      return {
        ...state,
        heroConfigLoading: true
      }
    case GET_HERO_CONFIG_SUCCESS:
      return {
        ...state,
        heroConfigLoading: false,
        heroConfigList: action.payload
      }
    case GET_HERO_CONFIG_FAILURE:
      return {
        ...state,
        error: action.error,
        heroConfigLoading: false
      }
    case SAVE_HERO_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_PROFILE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_IMAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_IMAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_IMAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CHECK_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CHECK_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CHECK_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case STORE_HERO_DATA:
      return {
        ...state,
        me: {}
      }
    default:
      return state
  }
}

// Action Creators
export const getHeroLocationList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_HERO_LOCATION_LIST_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/heroMap`)

      if (response.status === 200) {
        dispatch({
          type: GET_HERO_LOCATION_LIST_SUCCESS,
          payload: response.data
        })
      }
    } catch (err) {
      dispatch({
        type: GET_HERO_LOCATION_LIST_FAILURE
      })
    }
  }
}

export const getAllHeroes = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_HERO_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/all`)

      if (response.status === 200) {
        dispatch({
          type: GET_ALL_HERO_SUCCESS,
          payload: response.data
        })
      }
    } catch (err) {
      dispatch({
        type: GET_ALL_HERO_FAILURE
      })
    }
  }
}

export const getHeroMe = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_HERO_ME_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/me`)
      dispatch({
        type: GET_HERO_ME_SUCCESS,
        payload: response.data.data
      })
    } catch (err) {
      dispatch({
        type: GET_HERO_ME_FAILURE
      })
    }
  }
}

export const getHeroConfigs = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_HERO_CONFIG_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/hero-config`)
      dispatch({
        type: GET_HERO_CONFIG_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_HERO_CONFIG_FAILURE
      })
    }
  }
}

export const saveHeroMaterial = (data, enqueueSnackbar, heroId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_MATERIAL_REQUEST
      })

      await API.post(EndPoints.HERO + `/material/${heroId}`, data)
      dispatch({
        type: SAVE_HERO_MATERIAL_SUCCESS
      })
      enqueueSnackbar(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      enqueueSnackbar(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_MATERIAL_FAILURE
      })
    }
  }
}

export const saveHeroSetting = (data, enqueueSnackbar) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_SETTING_REQUEST
      })

      await API.post(EndPoints.HERO + '/active', data)
      dispatch({
        type: SAVE_HERO_SETTING_SUCCESS
      })
      enqueueSnackbar(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      enqueueSnackbar(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_SETTING_FAILURE
      })
    }
  }
}

export const updateHeroProfile = (data, enqueueSnackbar) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERO_PROFILE_REQUEST
      })

      await API.post(EndPoints.HERO + `/update-profile`, data)
      dispatch({
        type: UPDATE_HERO_PROFILE_SUCCESS
      })
      enqueueSnackbar(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      enqueueSnackbar(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERO_PROFILE_FAILURE
      })
    }
  }
}

export const resetPassword = (data, enqueueSnackbar) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: RESET_PASSWORD_REQUEST
      })

      const response = await API.post(EndPoints.HERO + `/reset-password`, data)
      if (response.data.data) {
        dispatch({
          type: RESET_PASSWORD_SUCCESS
        })
        enqueueSnackbar(RESPONSE_MESSAGE.SUCCESS)
      } else {
        dispatch({
          type: RESET_PASSWORD_FAILURE
        })
        enqueueSnackbar(response.data.message)
      }
    } catch (err) {
      enqueueSnackbar(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: RESET_PASSWORD_FAILURE
      })
    }
  }
}

export const resetHeroPassword = (data, enqueueSnackbar) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CHECK_RESET_PASSWORD_REQUEST
      })

      const response = await API.post(EndPoints.HERO + `/resetPassword`, data)
      if (response.data.data) {
        dispatch({
          type: CHECK_RESET_PASSWORD_SUCCESS
        })
        enqueueSnackbar(RESPONSE_MESSAGE.SUCCESS)
      } else {
        dispatch({
          type: CHECK_RESET_PASSWORD_FAILURE
        })
        enqueueSnackbar(response.data.message)
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.message)
      dispatch({
        type: CHECK_RESET_PASSWORD_FAILURE
      })
    }
  }
}

export const saveHeroImage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_IMAGE_REQUEST
      })

      await API.post(EndPoints.HERO + `/image-profile`, data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
      dispatch({
        type: SAVE_HERO_IMAGE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_IMAGE_FAILURE
      })
    }
  }
}

export const removeStoreHero = () => {
  return async (dispatch) => {
    dispatch({
      type: STORE_HERO_DATA
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/hero.js